import { render, staticRenderFns } from "./Box10.vue?vue&type=template&id=13606f11&scoped=true&"
import script from "./Box10.vue?vue&type=script&lang=js&"
export * from "./Box10.vue?vue&type=script&lang=js&"
import style0 from "./Box10.vue?vue&type=style&index=0&id=13606f11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13606f11",
  null
  
)

export default component.exports